<template>
  <div class="xmlc" v-loading="loadingData" element-loading-text="拼命加载中">
    <myHeader></myHeader>
    <!-- <div class="tip">
      进入项目流程请务必使用兼容模式。若当前非兼容模式请返回项目列表切换至兼容模式后再进入项目流程
    </div> -->
    <div class="xmlcHeader">
      <p class="xmmc"><span v-if="kbxmZt == '3'">开标已终止</span>{{ xmmc }}</p>
      <div class="rt doLists">
        <!-- <el-button type="text" @click="ask" v-if="role != 'Z'">提疑/答疑<el-badge class="mark" :value="num"/></el-button> -->
        <el-button type="text" @click="ask"
          >提疑/答疑<el-badge class="mark" :value="num"
        /></el-button>
        <template v-if="role == 'Z'">
          <start-share :bdId="bdId" ref="share" v-if="bdId" />
          <el-button type="text" @click="stopKb">终止开标</el-button>
        </template>
        <el-button type="text" class="goList" @click="goKbxmList"
          >返回项目列表</el-button
        >
      </div>
    </div>
    <div class="content" :class="[{ tbrView: role == 'B' }]">
      <!-- 流程节点 -->
      <ul class="lcSteps" v-if="lcSteps.length && role != 'B'">
        <template v-for="(item, index) in lcSteps">
          <li :key="index" v-if="item.zt == '0'">{{ item.ycmc }}</li>
          <router-link
            v-else
            :key="index"
            :class="[{ over: item.zt != '0' }]"
            tag="li"
            :to="{ path: item.ycdz, query: { djlcId: item.id, bdId: bdId, xmdl: xmdl } }"
            >{{ item.ycmc }}</router-link
          >
        </template>
      </ul>
      <!-- 视频留言区域 -->
      <div>
        <div :class="['left', { allWidth: !isOpen }]">
          <!-- 流程页面 -->
          <router-view
            @nextBtn="nextBtn"
            ref="zb"
            @send="send"
            v-if="role != 'B'"
          ></router-view>
          <router-view ref="tb" @send="send" v-else></router-view>
        </div>
        <div :class="['right', { open: !isOpen }]">
          <!-- <myVideoZb v-if="sxtLx == 'zb'" ref="myVideo"></myVideoZb>
          <myVideoQt v-else ref="myVideo"></myVideoQt> -->
          <myVideoYsy ref="myVideo" :bdId="bdId"></myVideoYsy>
          <myMsg v-if="xmmc" @send="send" ref="msg"></myMsg>
        </div>
      </div>
      <p
        :class="['openOrclose', role == 'B' ? 'tbr' : '', { open: isOpen }]"
        @click="isOpen = !isOpen"
      >
        {{ isOpen ? "隐藏直播" : "显示直播" }}
      </p>
      <!-- 提示弹窗 -->
      <!-- <div class="questionsTips" @click="ask" v-if="role != 'Z' && colseBtn"> -->
      <div class="questionsTips" @click="ask" v-if="colseBtn">
        <div class="tipsContent">
          <p>您还有{{ residueNum }}条新消息待处理！</p>
        </div>
        <img
          class="xBtn"
          @click.stop="closeTips"
          src="../assets/images/xbtn.png"
          alt=""
        />
      </div>
    </div>
    <!-- 投标人提疑列表-->
    <template v-if="role != 'Z'">
      <!-- v-if="role == 'B'" -->
      <el-dialog
        title="提疑"
        :visible.sync="tyTableVisible"
        width="849.999975px"
        lock-scroll
        :close-on-click-modal="false"
      >
        <!-- :disabled="disabledJxzKbxmlc" -->
        <el-button
          type="primary"
          style="margin-bottom: 9.999975px"
          @click="addTy"
          >新增</el-button
        >
        <el-table :data="tableList" border>
          <el-table-column property="index" label="序号" width="50">
            <template slot-scope="scope">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</template>
          </el-table-column>
          <el-table-column
            property="tybt"
            label="标题"
            min-width="150"
          ></el-table-column>
          <el-table-column
            property="tysj"
            label="提疑时间"
            width="180"
          ></el-table-column>
          <el-table-column
            property="tbdwmc"
            label="单位名称"
            min-width="150"
          ></el-table-column>
          <el-table-column property="hfnr" label="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.hfnr == ''" class="red">待回复</span>
              <span v-else class="success">已回复</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="look(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <myPage
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
        <div class="btnBox">
          <el-button type="primary" @click="closeDialog">确定</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="新增提疑"
        :visible.sync="addTyVisible"
        width="950px"
        lock-scroll
        :close-on-click-modal="false"
        class="addMaxHeight"
      >
        <el-form :model="form" label-width="80px" ref="form">
          <el-form-item
            label="投标单位"
            prop="tbdwmc"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
          >
            <!-- <template v-if="role == 'B'">
              <el-input
                v-model="form.tbdwmc"
                autocomplete="off"
                disabled
              ></el-input>
            </template>
            <template v-else> -->
              <el-select v-model="form.tbdwmc" :disabled="role == 'B'" placeholder="请选择单位">
                <el-option
                  v-for="item in options"
                  :key="item.fcqyjgdm"
                  :label="item.fcqymc"
                  :value="item.fcqyjgdm"
                >
                </el-option>
              </el-select>
            <!-- </template> -->
          </el-form-item>
          <el-form-item
            label="标题"
            prop="tybt"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
          >
            <el-input v-model="form.tybt" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            label="提疑内容"
            prop="tynr"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
          >
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="form.tynr"
            >
            </el-input>
            <!-- <VueUeditorWrap
              v-model="form.tynr"
              :config="editorConfig"
              class="editorMargin"
            ></VueUeditorWrap> -->
          </el-form-item>
          <el-form-item label="附件">
            <div class="addFileBox">
              <p>
                <el-upload
                  style="display: inline"
                  :action="upUrl"
                  :show-file-list="false"
                  :on-success="fileUpSuccess"
                  :on-error="fileUpError"
                  :before-upload="beforeUpload"
                  :with-credentials="true"
                  accept=".pdf,.doc,.docx,.jpg,.png,.JPG,.PDF,.DOC,.DOCX,.PNG"
                  :data="requestParams"
                >
                  <el-button
                    :disabled="hadQz"
                    class="upBtn"
                    type="primary"
                    @click="setActionUrl"
                    >{{ hadQz ? "已上传" : "上传" }}</el-button
                  >
                </el-upload>
                <span>注：仅支持上传doc、docx、pdf、jpg、png文件</span>
              </p>
              <ul v-for="(item, index) in alreadyUpFileList" :key="index">
                <li class="fileItem">
                  <p>
                    <img
                      src="../assets/images/icon_pdf.png"
                      alt=""
                      class="fileIcon"
                    />
                    {{ item.name }}
                  </p>
                  <p class="twoIcon">
                    <!-- 下载 -->
                    <img
                      class="upIcon"
                      src="../assets/images/loadIcon.png"
                      alt=""
                      @click.stop="downloadFile(item)"
                    />
                    <span style="opacity: 0.2">|</span>
                    <!-- 删除 -->
                    <img
                      class="delIcon"
                      src="../assets/images/delIcon.png"
                      alt=""
                      @click.stop="clickDelFile(item, index)"
                    />
                  </p>
                </li>
              </ul>
            </div>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button type="primary" @click="saveTyhf('form')">确定</el-button>
        </div>
      </el-dialog>
      <!-- 查看提疑回复 -->
      <el-dialog
        title="查看"
        :visible.sync="lookReply"
        width="950.000025px"
        lock-scroll
        :close-on-click-modal="false"
        @close="colseLookpage"
        class="maxHeight"
      >
        <div class="ask">
          <p>
            {{ dy.tybt }} <span>{{ dy.tysj }}</span>
          </p>
          <div class="askFileList">
            <div v-html="dy.tynr"></div>
            <br />
            <p class="boldFont" v-if="dy.tyfj && dy.tyfj.length > 0">附件</p>
            <ul v-for="(item, index) in dy.tyfj" :key="index">
              <li class="fileItem">
                <p>
                  <img
                    src="../assets/images/icon_pdf.png"
                    alt=""
                    class="fileIcon"
                  />
                  {{ item.tywjm }}
                </p>
                <p class="twoIcon">
                  <!-- 下载 -->
                  <img
                    class="upIcon"
                    src="../assets/images/loadIcon.png"
                    alt=""
                    @click="downloadFile(item, 2)"
                  />
                </p>
              </li>
            </ul>
            <p class="right">{{ dy.tbdwmc }}</p>
          </div>
        </div>
        <template v-if="!dy.hfnr">
          <template v-if="dy.tbdwmc != userName">
            <div class="ask">
              <p class="replyText">回复:</p>
              <el-input
                type="textarea"
                :autosize="{ minRows: 3 }"
                v-model="replytextarea"
              >
              </el-input>
            </div>
            <div class="fileBox">
              <p>
                <span class="boldFont">附件</span>
                <el-upload
                  style="display: inline"
                  :action="upUrl"
                  :show-file-list="false"
                  :on-success="fileUpSuccess"
                  :on-error="fileUpError"
                  :before-upload="beforeUpload"
                  :with-credentials="true"
                  accept=".pdf,.doc,.docx,.jpg,.png,.JPG,.PDF,.DOC,.DOCX,.PNG"
                  :data="requestParams"
                >
                  <el-button
                    :disabled="hadQz"
                    class="upBtn"
                    type="primary"
                    @click="setActionUrl"
                    >{{ hadQz ? "已上传" : "上传" }}</el-button
                  >
                </el-upload>
                <span>注：仅支持上传doc、docx、pdf、jpg、png文件</span>
              </p>
              <ul v-for="(item, index) in alreadyUpFileList" :key="index">
                <li class="fileItem">
                  <p>
                    <img
                      src="../assets/images/icon_pdf.png"
                      alt=""
                      class="fileIcon"
                    />
                    {{ item.name }}
                  </p>
                  <p class="twoIcon">
                    <!-- 下载 -->
                    <img
                      class="upIcon"
                      src="../assets/images/loadIcon.png"
                      alt=""
                      @click="downloadFile(item)"
                    />
                    <span style="opacity: 0.2">|</span>
                    <!-- 删除 -->
                    <img
                      class="delIcon"
                      src="../assets/images/delIcon.png"
                      alt=""
                      @click="clickDelFile(item, index)"
                    />
                  </p>
                </li>
              </ul>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="ask">
            <p>
              回复：{{ dy.tybt }} <span>{{ dy.hfsj }}</span>
            </p>
            <div class="askFileList">
              <div v-html="dy.hfnr"></div>
              <br />
              <p class="boldFont" v-if="dy.hffj && dy.hffj.length > 0">附件</p>
              <ul v-for="(item, index) in dy.hffj" :key="index">
                <li class="fileItem">
                  <p>
                    <img
                      src="../assets/images/icon_pdf.png"
                      alt=""
                      class="fileIcon"
                    />
                    {{ item.hfwjm }}
                  </p>
                  <p class="twoIcon">
                    <!-- 下载 -->
                    <img
                      class="upIcon"
                      src="../assets/images/loadIcon.png"
                      alt=""
                      @click="downloadFile(item, 3)"
                    />
                  </p>
                </li>
              </ul>
              <p class="right">{{ dy.hfdwmc }}</p>
            </div>
          </div>
        </template>

        <div class="btnBox">
          <el-button type="primary" @click="replyMessage">确定</el-button>
        </div>
      </el-dialog>
    </template>
    <!-- 主持人答疑弹窗 -->
    <template v-else>
      <el-dialog
        title="答疑"
        :visible.sync="dyTableVisible"
        width="950.000025px"
        lock-scroll
        :close-on-click-modal="false"
      >
        <el-table :data="tableList" border>
          <el-table-column property="index" label="序号" width="50">
            <template slot-scope="scope">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</template>
          </el-table-column>
          <el-table-column
            property="tbdwmc"
            label="投标单位"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="tybt"
            label="标题"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            property="tysj"
            label="提疑时间"
            width="160"
          ></el-table-column>
          <el-table-column property="hfnr" label="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.hfnr == ''" class="red">待回复</span>
              <span v-else class="success">已回复</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="replyOrLook(scope.row, false)"
                v-if="scope.row.hfnr == '' && role == 'Z'"
                >回复</el-button
              >
              <el-button
                type="text"
                @click="replyOrLook(scope.row, true)"
                v-else
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <myPage
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
        <div class="btnBox">
          <el-button type="primary" @click="dyTableVisible = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 回复/查看答疑 -->
      <el-dialog
        :title="isLook ? '查看' : '回复'"
        :visible.sync="replyAndLook"
        width="950.000025px"
        lock-scroll
        :close-on-click-modal="false"
      >
        <div class="ask">
          <p>
            {{ dy.tybt }} <span>{{ dy.tysj }}</span>
          </p>
          <div>
            <div v-html="dy.tynr"></div>

            <div class="askFileList">
              <div v-html="dy.tynr"></div>
              <br />
              <p class="boldFont" v-if="dy.tyfj && dy.tyfj.length > 0">附件</p>
              <ul v-for="(item, index) in dy.tyfj" :key="index">
                <li class="fileItem">
                  <p>
                    <img
                      src="../assets/images/icon_pdf.png"
                      alt=""
                      class="fileIcon"
                    />
                    {{ item.tywjm }}
                  </p>
                  <p class="twoIcon">
                    <!-- 下载 -->
                    <img
                      class="upIcon"
                      src="../assets/images/loadIcon.png"
                      alt=""
                      @click="downloadFile(item, 2)"
                    />
                  </p>
                </li>
              </ul>
              <p class="right">{{ dy.tbdwmc }}</p>
            </div>
          </div>
        </div>
        <div class="reply">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="reply"
            v-if="!isLook"
          >
          </el-input>
          <!-- <VueUeditorWrap
            v-model="reply"
            :config="editorConfig"
            v-if="!isLook"
          ></VueUeditorWrap> -->
          <template v-else>
            <span class="lf">回复：</span>
            <div class="hfnr" v-html="dy.hfnr"></div>
            <p class="right">{{ dy.hfsj }}</p>
            <p class="right">{{ dy.hfdwmc }}</p>
          </template>
        </div>
        <div class="btnBox">
          <el-button type="primary" @click="saveHfnr" :disabled="!reply"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 终止开标 -->
      <el-dialog
        title="终止开标"
        :visible.sync="dialogStopKb"
        width="500.000025px"
        lock-scroll
        :close-on-click-modal="false"
      >
        <el-form :model="stopKbForm" label-width="99.999975px">
          <el-form-item label="终止开标原因">
            <el-input type="textarea" v-model="stopKbForm.yy"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button type="primary" @click="saveStopKb">确定</el-button>
        </div>
      </el-dialog>
    </template>
    <!-- iframe -->
    <template v-if="isShowSureQzDialog">
      <div class="atOnceOpen">
        <el-dialog
          title="签章"
          :visible.sync="isShowSureQzDialog"
          lock-scroll
          :close-on-click-modal="false"
        >
          <div class="button-wrapper">
            <span class="qz-text">正在签章中</span>
            <button type="primary" @click="sureQz" class="sure-qz">
              确认签章
            </button>
          </div>
        </el-dialog>
      </div>
    </template>
  </div>
</template>
<script>
// import myVideoZb from "../components/video/videoZb";
import myVideoYsy from "../components/video/videoYsy.vue";
import startShare from "../components/video/startShare.vue";
// import myVideoQt from "../components/video/videoQt";
import myMsg from "../components/msg";
import myPage from "../components/page";
import myHeader from "../components/header";
import { Message } from "element-ui";
import WebSocketMixin from '../mixins/WebSocketMixin';

export default {
  name: "xmlc",
  components: {
    // myVideoZb,
    // myVideoQt,
    myVideoYsy,
    startShare,
    myMsg,
    myPage,
    myHeader,
  },
  mixins: [WebSocketMixin],
  data() {
    return {
      bdId: localStorage.getItem("bdId") ? localStorage.getItem("bdId") : "",
      sxtLx: localStorage.getItem("sxtLx")
        ? localStorage.getItem("sxtLx")
        : "qt",
      xmdl: "",
      xmmc: localStorage.getItem("xmmc") ? localStorage.getItem("xmmc") : "",
      kbxmZt: localStorage.getItem("kbxmZt")
        ? localStorage.getItem("kbxmZt")
        : "",
      lcSteps: JSON.parse(localStorage.getItem("lcSteps"))
        ? JSON.parse(localStorage.getItem("lcSteps"))
        : [],
      userName: localStorage.getItem("user")
        ? localStorage.getItem("user")
        : "",
      isOpen: true,
      dyTableVisible: false, //答疑列表显示隐藏
      tableList: [], //答疑列表,提疑列表
      total: 0,
      currentPage: 1,
      pageSize: 10,
      replyAndLook: false, //回复查看答疑弹窗
      //答疑对象
      dy: {
        tybt: "",
        tysj: "",
        tynr: "",
        tbdwmc: "",
      },
      reply: "", //回复内容
      isLook: false, //是否是查看还是回复
      tyTableVisible: false, //提疑弹窗是否显示
      addTyVisible: false, //新增提疑弹窗
      form: {
        tbdwmc: "",
        tybt: "",
        tynr: "",
      }, //提疑表单
      lookReply: false, //查看回复
      flag: false,
      num: "", //答疑的待回复条数
      editorConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 200,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口, 报错属于正常，若需要验证可使用(也是盗大神的)http://35.201.165.105:8000/controller.php
        // 调试完毕打包上线则切换回/static/UEditor/php/controller.php即可，不用做其他处理
        serverUrl: "/api/v2/ueditor/ueditorConfig",
        UEDITOR_HOME_URL: "/UEditor/", //UEditor资源文件的存放路径
        zIndex: 9999,
        toolbars: [["bold", "simpleupload", "insertimage", "attachment"]],
      },
      dialogStopKb: false,
      stopKbForm: {},
      colseBtn: false, // 默认为false，当有未查看的消息是为true
      replytextarea: "",
      alreadyUpFileList: [],
      options: [],
      pdfUrl: "",
      dialogQzChoose: false,
      residueNum: "",
      upUrl: "",
      qzUrl: "",
      dialogQz: false,
      requestParams: {},
      iframeObj: {},
      cancelList: [],
      timer: null,
      loadingData: false,
      disabledJxzKbxmlc: false,
      isShowSureQzDialog: false,
      hadQz: false,
    };
  },
  computed: {
    role() {
      return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
    },
  },
  methods: {
    async sureQz() {
      console.log(this.iframeObj, "sure qz");
      // 确认签章弹窗
      const res = await this.$api.checkHasQz(this.iframeObj.id);
      console.log(res, "checkHasQz");
      if (res?.data?.meta?.success) {
        if (res?.data?.data?.zbrzt === "2-1") {
          this.hadQz = true;
          this.isShowSureQzDialog = false;
          this.$message({
            message: "签章成功",
            type: "success",
          });
          this.qzSuccess();
        } else {
          this.isShowSureQzDialog = true;
          this.$message({
            message: "签章正在进行中~",
            type: "warning",
          });
        }
      } else {
        this.isShowSureQzDialog = true;
        this.$message.error(res?.meta?.message || "请求失败，请稍后重试！");
      }
    },
    getKaibiao() {
      console.log(localStorage.getItem("role"), 'localStorage.getItem("role")');
      let para = {};
      this.$api.getMsg(para).then((res) => {
        if (res.data.meta.success) {
          if (res.data.data.jxzKbxmlc === "开标结束") {
            this.disabledJxzKbxmlc = true;
          }
        }
      });
    },
    getKbxm() {
      let para = {
        bdId: this.bdId,
        xmdl: this.xmdl,
      };
      this.isOpen = false;
      this.loadingData = true;
      this.$api
        .kbxm(para)
        .then((res) => {
          if (res.data.meta.success) {
            if (res.data.data.kbxm.fcxmmc == res.data.data.kbxm.fcbdmc) {
              this.xmmc = res.data.data.kbxm.fcxmmc;
            } else {
              this.xmmc = res.data.data.kbxm.fcxmmc + res.data.data.kbxm.fcbdmc;
            }
            this.kbxmZt = res.data.data.kbxm.zt;
            localStorage.setItem("xmmc", this.xmmc);

            //#region 如果来源是 list，则跳转到进行中的节点路由
            const { from } = this.$route.query;
            if (from === 'list') {
              if (this.role == "B") {
                this.$router.push({ path: "/tbView" });
              } else {
                this.lcSteps = res.data.data.kbxmlcList;
                localStorage.setItem("lcSteps", JSON.stringify(this.lcSteps));
                const activeStep = this.lcSteps.find(s => s.zt === '1')
                this.$router.push({
                  path: activeStep.ycdz,
                  query: { djlcId: activeStep.id, bdId: this.bdId, xmdl: this.xmdl },
                });
              }
            }
            //#endregion

            this.isOpen = true;
            this.$nextTick(() => {
              this.tyList();
            });
            this.$refs.myVideo.getSxt();
            this.loadingData = false;
          } else {
            this.$message({
              message: res.data.meta.message,
              type: "error",
            });
            this.loadingData = false;
          }
        })
        .catch(() => {});
    },
    // 获取未读数据的数量
    tyhfwdlist() {
      this.$api
        .tyhfwdlist()
        .then((res) => {
          this.residueNum = res.data?.data;
          if (this.residueNum > 0) {
            this.colseBtn = true;
          } else {
            this.colseBtn = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loopQuestTyList(time) {
      this.timer = setInterval(() => {
        this.tyhfwdlist();
      }, time);
    },
    // 获取投标人列表
    jszlist() {
      this.$api
        .jszlist()
        .then((res) => {
          this.options = res.data.data.jszList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setActionUrl() {
      // this.upUrl = "http://localhost:8080" + "/api/v2/jc/tyhf/uploadtyfile";
      this.upUrl = process.env.VUE_APP_BASE_URL + "/api/v2/jc/tyhf/uploadtyfile";
    },
    //返回开标项目列表
    goKbxmList() {
      this.$router.push("/kbxmList");
      localStorage.removeItem("lcSteps");
      localStorage.removeItem("xmmc");
      localStorage.removeItem("bdId");
      localStorage.removeItem("kbxmZt");
      localStorage.removeItem("sxtLx");
    },
    //投保人提疑
    ask() {
      this.getKaibiao();
      this.tyTableVisible = true;
      this.dyTableVisible = true; // 招标人也显示弹窗
      this.tyList();
      this.currentPage = 1;
    },
    colseLookpage() {
      this.replytextarea = "";
      this.tyList();
    },
    //提疑、答疑的列表数据获取
    tyList() {
      let para = {
        pageSize: this.pageSize,
        currentPage: this.currentPage,
      };
      this.$api
        .tyList(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.total = res.data.data.total || 0;
            this.tableList = res.data.data.list || [];
            this.num = res.data.data.yhfCount + "/" + res.data.data.totalCount;
          }
          this.tyhfwdlist(); // 获取未读数据的数量
          this.filebefore();
        })
        .catch(() => {});
    },
    //投保人查看提疑
    look(obj) {
      this.lookReply = true;
      this.dy = obj;
      this.alreadyUpFileList = [];
      this.tyhfForm(obj.id);
    },
    tyhfForm(id) {
      let para = {
        id,
      };
      this.$api
        .tyhfForm(para)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.statusText,
          });
        });
    },
    //投保人新增提疑
    addTy() {
      this.addTyVisible = true;
      this.alreadyUpFileList = [];
      this.form = {
        tybt: "",
        tynr: "",
      };
      this.hadQz = false;
      if (this.role == "B") {
        this.form = {
          tbdwmc: localStorage.getItem("jgdm"),
        };
      } else {
        this.form = {
          tbdwmc: "",
        };
      }
      this.jszlist(); // 获取投标人列表
    },
    //提交提疑
    saveTyhf(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let cancelList = this.alreadyUpFileList.map((item) => {
            return item.dataId;
          });
          this.waitLoading = true;
          let para = {
            tybt: this.form.tybt,
            tynr: this.form.tynr,
            jszjgdm: this.form.tbdwmc,
            bidfilesId: cancelList.join("/"),
          };
          this.$api
            .saveTyhf(para)
            .then((res) => {
              if (res.data.meta.success) {
                this.addTyVisible = false;
                this.tyList();
                let obj = {
                  lx: "ty",
                  data: {},
                };
                this.send(JSON.stringify(obj));
              } else {
                this.$message.error(
                  res?.data?.meta?.message || "保存失败，请稍后重试"
                );
              }
              this.waitLoading = false;
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //答疑列表
    changePage(page) {
      this.currentPage = page;
      this.tyList();
    },
    //招标人打开答疑列表
    qAndA() {
      this.dyTableVisible = true;
      this.tyList();
    },
    closeTips() {
      this.colseBtn = false;
    },
    //查看或回复答疑
    replyOrLook(obj, flag) {
      this.replyAndLook = true;
      this.dy = obj;
      this.isLook = flag;
      this.reply = "";
    },
    saveHfnr() {
      if (this.isLook) {
        this.replyAndLook = false;
      } else {
        let para = {
          id: this.dy.id,
          hfnr: this.reply,
        };
        this.waitLoading = true;
        this.$api
          .saveTyhf(para)
          .then((res) => {
            if (res.data.meta.success) {
              this.replyAndLook = false;
              let obj = {
                lx: "ty",
                data: {},
              };
              this.send(JSON.stringify(obj));
            } else {
              this.$message.error(
                res?.data?.meta?.message || "保存失败，请稍后重试"
              );
            }
            this.waitLoading = false;
          })
          .catch(() => {});
      }
    },
    stopKb() {
      this.dialogStopKb = true;
      this.stopKbForm = {
        yy: "",
      };
    },
    saveStopKb() {
      let para = this.stopKbForm;
      this.waitLoading = true;
      this.$api
        .saveStopKb(para)
        .then((res) => {
          if (res.data.meta.success) {
            //通知投标人获取新的节点
            this.$message({
              type: "success",
              message: "开标已终止！",
            });
            this.$refs.share.stopShare();
            this.dialogStopKb = false;
            let obj = {
              lx: "kbzz",
              data: {
                id: "",
              },
            };
            this.send(JSON.stringify(obj));
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //主持人人走下一步操作
    nextBtn(para) {
      if (this.flag) {
        return;
      }
      this.flag = true;
      this.waitLoading = true;
      this.$api
        .nextBtn(para)
        .then((res) => {
          this.flag = false;

          if (res.data.meta.success) {
            this.lcSteps = res.data.data.kbxmlcList;
            localStorage.setItem("lcSteps", JSON.stringify(this.lcSteps));
            this.$router.push({
              path: res.data.data.nextKbxmlc.ycdz,
              query: { djlcId: res.data.data.nextKbxmlc.id, bdId: this.bdId, xmdl: this.xmdl },
            });
            this.$refs.msg.getMsg();
            let obj = {
              lx: "next",
              data: {},
            };
            this.send(JSON.stringify(obj));
            //开标结束
            if (para.isOver) {
              this.$refs.share.stopShare();
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {
          this.flag = false;
        });
    },

    //投标人签到解密确认操作
    tbrDo(lx) {
      this.$refs.tb.tbrDo(lx);
    },

    // 重写 WebSocket 消息处理方法
    webSocketMessage(obj) {
      console.log('WebSocket message:', obj);
      let lx = obj.lx;
      if (lx == "ty") {
        this.tyList();
      } else if (lx == "kbzz") {
        this.kbxmZt = "3";
        localStorage.setItem("kbxmZt", "3");
      } else if (lx == "zbr") {
        //主持人选择人工有效性审查后通知招标人开始审查
        if (this.$refs.zb) {
          if (this.role == "T" || this.role == "A") {
            this.$refs.zb.getData();
          }
        }
        if (this.$refs.tb) {
          this.$refs.tb.getData();
        }
      } else if (lx == "kbzcr") {
        //招标人审查完成后通知主持人下一步操作
        if (this.$refs.zb) {
          if (this.role == "Z") {
            this.$refs.zb.getData();
          }
        }
        if (this.$refs.tb && this.$refs.msg) {
          this.$refs.tb.getData();
        }
      } else if (lx == "sqbj") {
        //投标人发起补救申请
        //投标人发起申请补救
        if (this.$refs.zb) {
          this.$refs.zb.getSqbjList();
        }
      } else if (lx == "sqbjJg") {
        //同意或拒绝补救申请
        //对应投标人页面刷新
        var ids = obj.data.id.split(",");
        ids.forEach((item) => {
          if (item == localStorage.getItem("jgdm")) {
            if (this.$refs.tb) {
              this.$refs.tb.getData();
            }
          }
        });
        //同时通知除主持人之外的其他人招标类型刷新数据
        if (this.role != "Z" && this.$refs.zb) {
          this.$refs.zb.getSqbjList();
        }
      } else if (lx == "tb") {
        //投标人页面操作
        if (this.$refs.zb) {
          this.$refs.zb.getData();
        }
      } else if (lx == "msg" && this.$refs.msg) {
        this.$refs.msg.websockMessage(JSON.stringify(obj.data));
      } else if (lx == "next") {
        if (this.$refs.zb) {
          //主持人走下一步按钮后（有下一步操作），招标人，招标代理，监管人员也要重新获取节点，加onlyRead表示不（下一步）操作只获取节点
          let para = {
            flag: "onlyRead",
          };
          this.$api
            .nextBtn(para)
            .then((res) => {
              if (res.data.meta.success) {
                this.lcSteps = res.data.data.kbxmlcList;
                localStorage.setItem("lcSteps", JSON.stringify(this.lcSteps));
                this.$router.push({
                  path: res.data.data.nextKbxmlc.ycdz,
                  query: { djlcId: res.data.data.nextKbxmlc.id },
                });
                this.$refs.msg.getMsg();
              } else {
                this.$message({
                  type: "error",
                  message: res.data.meta.message,
                });
              }
            })
            .catch(() => {});
        }
        if (this.$refs.tb) {
          this.$refs.tb.getData();
          this.$refs.msg.getMsg();
        }
      } else if (lx == 'kqjm') {
        console.log('解密完成，重新拉取页面！');
        if (this.$refs.zb) {
          this.$refs.zb.getData();
        } else if (this.$refs.tb) {
          this.$refs.tb.getData();
        }
      } else if (lx == 'kbjshzz') {
        console.log('开标结束，关闭直播通道！');
        if (this.$refs.myVideo) {
          this.$refs.myVideo.closeVideo();
        }
      } else {
        //lx=="zb"
        //主持人页面操作后，去通知投标人
        if (obj.data.id) {
          //对应投标人页面刷新
          var ids = obj.data.id.split(",");
          ids.forEach((item) => {
            if (item == localStorage.getItem("jgdm")) {
              if (this.$refs.tb) {
                this.$refs.tb.getData();
              }
            }
          });
          //同时通知除主持人之外的其他人招标类型刷新数据
          if (this.role != "Z" && this.$refs.zb) {
            this.$refs.zb.getData(3);
            console.log("主持人页面投标人操作后通知其他人");
          }
        } else {
          //开启签到、解密、确认、有效性审查自动审查通过等
          if (this.$refs.tb && this.$refs.msg) {
            this.$refs.tb.getData();
            this.$refs.msg.getMsg();
          }
          //通知重新获取页面
          if (this.$refs.zb) {
            this.$refs.zb.getData(4);
            console.log("主持人操作后通知其他人");
          }
        }
      }
    },
    send(data) {
      this.sendWebSocketMessage(data);
    },
    // 文件上传之前
    beforeUpload(file) {
      if (this.hadQz) {
        return this.$message({
          message: "您已上传了文件",
          type: "warning",
        });
      }
      this.loadingData = true;
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = [
        "pdf",
        "doc",
        "docx",
        "jpg",
        "png",
        "PDF",
        "DOC",
        "DOCX",
        "JPG",
        "PNG",
      ];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error("上传文件只能是 doc、docx、pdf、jpg、png格式");
        this.loadingData = false;
        return false;
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传文件大小不能超过 50MB");
        this.loadingData = false;
        return false;
      }
    },
    // 文件上传成功
    fileUpSuccess(res) {
      this.loadingData = false;
      console.log("文件上传成功", res.data);
      this.cancelList = {
        name: res.data.filename,
        dataId: res.data.bidfilesId,
      };

      // for test
      // this.qzSuccess()
      // this.loadingData = false
      // return
      
      this.toGetPdfUrl(res.data.bidfilesId);
      this.getPdfData(res.data.bidfilesId, "look");
    },

    // 文件上传失败
    fileUpError() {
      this.loadingData = false;
      this.$message.error("文件上传失败,请重新上传");
    },
    filebefore() {
      this.$api
        .filebefore()
        .then((res) => {
          this.requestParams = {
            bdId: res.data.data.bdId,
            jgdm: res.data.data.jgdm,
            lx: res.data.data.lx,
            ryjs: res.data.data.ryjs,
            wjlx: 25,
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toGetPdfUrl(data) {
      let para = {
        bizfiledId: data,
        userName: this.userName,
      };
      this.$api
        .toSign(para)
        .then((res) => {
          this.iframeObj = {
            id: res.data.data.bizfiledId,
            type: res.data.data.caId,
            ryjs: res.data.data.ryjs,
            uname: res.data.data.userName,
            webURL: res.data.data.webURL,
            blockId: res.data.data.bdId,
            systemCode: res.data.data.systemCode,
            isTbr: res.data.data.isTbr,
            lx: res.data.data.lx,
            kbxmId: res.data.data.kbxmId,
            jgdm: res.data.data.jgdm,
          };
          // 文件上传成功之后就直接新页面去签章
          let obj = this.iframeObj;
          let url = ''
          if (process.env.VUE_APP_NODE === 'production') {
            url = 'http://pjyckb.zhaotx.cn'
          } else {
            url = process.env.VUE_APP_BASE_URL
          }
          window.open(
            `/qZ?type=${obj.type}&isTbr=${obj.isTbr}&userName=${obj.uname}&blockId=${obj.blockId}&systemCode=${obj.systemCode}&pdfUrl=${url}/api/v2/jc/tyhf/pdfview/${obj.id}/${obj.lx}&uploadUrl=${url}/api/v2/jc/tyhf/signDqcz/${obj.id}/${obj.uname}/${obj.kbxmId}/${obj.blockId}/${obj.jgdm}/${obj.lx}?ryjs=${obj.ryjs}`,
            "_blank"
          );
          this.isShowSureQzDialog = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadFile(item, num) {
      if (num == 2) {
        this.getPdfData(item.tyid, item.tywjm);
      } else if (num == 3) {
        this.getPdfData(item.hfid, item.hfwjm);
      } else {
        this.getPdfData(item.dataId, item.name);
      }
    },
    getPdfData(data, name) {
      this.$api
        .pdfshow({
          bidfilesId: data,
        })
        .then((res) => {
          this.loadPdfData(res.data, name);
        })
        .catch((err) => {
          this.$message({
            message: err.statusText,
            type: "error",
          });
        });
    },
    loadPdfData(data, name) {
      const blob = new Blob([data], {
        type: "application/pdf;chartset=UTF-8",
      });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, name);
      } else {
        const url = window.URL.createObjectURL(blob); // 创建下载的链接
        if (name == "look") {
          this.loadingData = false;
          this.pdfUrl = url;
        } else {
          const aTag = document.createElement("a");
          aTag.href = url;
          aTag.download = name;
          aTag.click(); // 点击下载
          window.URL.revokeObjectURL(url); // 释放掉blob对象
        }
      }
    },
    clickDelFile(item, index) {
      let a = this.$confirm(`确定移除 ${item.name}？`);
      a.then((res) => {
        this.delpdf(item, index);
      }).catch((err) => {
        this.$message({
          message: err.statusText,
          type: "error",
        });
      });
    },
    delpdf(item, index) {
      this.$api
        .delpdf({
          bizfiledId: item.dataId,
        })
        .then((res) => {
          this.alreadyUpFileList.splice(index, 1);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cancelQz() {
      this.pdfUrl = "";
    },
    goQz() {
      // this.dialogQzChoose = true;
      let obj = this.iframeObj;
      window.open(
        `/qZ??type=${obj.type}&isTbr=${obj.isTbr}&userName=${obj.uname}&blockId=${obj.blockId}&systemCode=${obj.systemCode}&pdfUrl=${process.env.VUE_APP_BASE_URL}api/v2/jc/tyhf/pdfview/${obj.id}/${obj.lx}&uploadUrl=${process.env.VUE_APP_BASE_URL}api/v2/jc/tyhf/signDqcz/${obj.id}/${obj.uname}/${obj.kbxmId}/${obj.blockId}/${obj.jgdm}/${obj.lx}?ryjs=${obj.ryjs}`,
        "_blank"
      );
    },
    closeQz() {
      this.qzUrl = "";
      this.dialogQz = false;
      this.dialogQzChoose = false;
    },
    qzSuccess() {
      this.qzUrl = "";
      this.dialogQz = false;
      this.dialogQzChoose = false;
      this.alreadyUpFileList.push({
        name: this.cancelList.name,
        dataId: this.cancelList.dataId,
      });
      console.log('qzSuccess', this.alreadyUpFileList, this.cancelList)
    },
    openNewWindow() {
      window.open(
        "https://jypt.zhaotx.cn/lc/lczt/toAppSign/ED1844DD8BAF48B6A606ED9B7581E114"
      );
    },
    gotoQz() {
      this.pdfUrl = "";
      let obj = this.iframeObj;
      // this.qzUrl = `https://ca.zhaotx.cn/test?type=${obj.type}&isTbr=${obj.isTbr}&userName=${obj.uname}&blockId=${obj.blockId}&systemCode=${obj.systemCode}&pdfUrl=${obj.webURL}api/v2/jc/tyhf/pdfview/${obj.id}/${obj.lx}&uploadUrl=${obj.webURL}api/v2/jc/tyhf/signDqcz/${obj.id}/${obj.uname}/${obj.kbxmId}/${obj.blockId}/${obj.jgdm}/${obj.lx}?ryjs=${obj.ryjs}`;
      this.qzUrl = `https://ca.zhaotx.cn/test?type=${obj.type}&isTbr=${obj.isTbr}&userName=${obj.uname}&blockId=${obj.blockId}&systemCode=${obj.systemCode}&pdfUrl=${obj.webURL}api/v2/jc/tyhf/pdfview/${obj.id}/${obj.lx}&uploadUrl=${obj.webURL}jc/tyhf/signDqcz/${obj.id}/${obj.uname}/${obj.kbxmId}/${obj.blockId}/${obj.jgdm}/${obj.lx}?ryjs=${obj.ryjs}`;
      // this.qzUrl = `https://ca.zhaotx.cn/test?type=${obj.type}&isTbr=${obj.isTbr}&userName=${obj.uname}&blockId=${obj.blockId}&systemCode=${obj.systemCode}&pdfUrl=${obj.webURL}jc/tyhf/pdfview/${obj.id}/${obj.lx}&uploadUrl=${obj.webURL}jc/tyhf/signDqcz/${obj.id}/${obj.uname}/${obj.kbxmId}/${obj.blockId}/${obj.jgdm}/${obj.lx}?ryjs=${obj.ryjs}`;
      this.dialogQz = true;
    },
    replyMessage() {
      if (this.dy.tbdwmc == this.userName || this.dy.hfnr) {
        this.lookReply = false;
        return;
      }
      let cancelList = this.alreadyUpFileList.map((item) => {
        return item.dataId;
      });
      console.log('replyMessage', this.alreadyUpFileList, 'cancelList', cancelList)
      let para = {
        hfnr: this.replytextarea,
        jszjgdm: this.dy.fqz,
        bidfilesId: cancelList.join("/"),
        id: this.dy.id,
      };
      this.$api
        .saveTyhf(para)
        .then((res) => {
          this.lookReply = false;
          if (!res?.data?.meta?.success) {
            this.$message.error(
              res?.data?.meta?.message || "保存失败，请稍后重试"
            );
          }
        })
        .catch((err) => {
          this.$message({
            message: err.statusText,
            type: "error",
          });
        });
    },
    closeDialog() {
      this.tyTableVisible = false;
    },
  },
  created() {
    // 初始化 WebSocket 参数
    this.wsParams = { bdId: this.$route.query.bdId };
  },
  mounted() {
    this.loopQuestTyList(60000);
    window.addEventListener(
      "message",
      (event) => {
        if (event.data.saveSign) {
          //签章完成保存签章
          this.qzSuccess();
        }
        if (event.data.isShare) {
          //屏幕分享状态
          window.isStartShare = event.data.isStartShare;
        }
      }
    );
    if (this.$route.query.bdId) {
      this.bdId = this.$route.query.bdId;
    }
    this.xmdl = this.$route.query.xmdl;
    if (this.xmdl) {
      localStorage.setItem("bdId", this.bdId);
      this.getKbxm();
    } else {
      this.tyList();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="less" scope>
.button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  .sure-qz {
    width: 98px;
    height: 40px;
    background-color: #0060b2;
    border-color: #0060b2;
    color: #fff;
    margin-top: 20px;
  }
}
.xmlc {
  height: calc(~"100% - 80.000025px");
}
.tip {
  width: 100%;
  height: 32px;
  line-height: 32px;
  background: #fffbe9;
  color: #f39800;
  font-weight: bold;
  text-align: center;
}
.xmlcHeader {
  background: #f3f3f3;
  height: 50.000025px;
  line-height: 50.000025px;
  border-bottom: 0.999975px solid #ddd;
  padding: 0 20.000025px;
  .xmmc {
    float: left;
    font-size: 18px;
    height: 50.000025px;
    color: #333;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    span {
      color: @base-color;
      font-weight: bold;
      margin-right: 9.999975px;
    }
  }
  .doLists {
    span {
      text-decoration: underline;
      color: #333;
      cursor: pointer;
      line-height: 30px;
    }
    .el-button.goList span {
      color: @base-color;
    }
    .changeModel span {
      color: #f39800;
    }
  }
}

.content {
  padding: 9.999975px 24.999975px 9.999975px 20.000025px;
  height: calc(~"100% - 168.999975px");
  position: relative;
  > div {
    min-height: 688px;
    height: calc(~"100% - 60px");
    .right {
      width: 480px;
      border: 0.999975px solid @border-color;
      padding: 9.999975px;
      background: #fdf0f3;
      height: calc(~"100% - 9.999975px");
      float: right;
    }
    .right.open {
      position: absolute;
      top: -99990px;
      left: -99999px;
    }
    .left {
      width: calc(~"100% - 489.999975px");
      float: left;
      height: calc(~"100% - 9.999975px");
      > div {
        height: 100%;
      }
    }
    .left.allWidth {
      width: 100%;
    }
  }
  div.box {
    border: 0.999975px solid #ddd;
    border-top: 2.000025px solid @base-color;
    background: @base-Bg;
    padding: 9.999975px;
    position: relative;
    padding-bottom: 82px;
  }
  div.box.noBtn {
    padding-bottom: 0;
  }
  .lcSteps {
    height: 50.000025px;
    margin-bottom: 9.999975px;
    li {
      float: left;
      width: 135px;
      height: 50.000025px;
      line-height: 50.000025px;
      border-radius: 3px;
      text-align: center;
      background: #ccc;
      color: #fff;
      cursor: not-allowed;
      font-size: 18px;
    }
    @media screen and (min-width: 1920.999975px) {
      li {
        width: 200.000025px;
      }
    }
    @media screen and (min-width: 1599.999975px) {
      li {
        width: 153px;
      }
    }
    li + li {
      margin-left: 20.000025px;
      position: relative;
    }
    li + li:after {
      position: absolute;
      content: "";
      display: block;
      width: 5.000025px;
      height: 50.000025px;
      background: url("../assets/images/jt2.jpg") no-repeat center;
      top: 0;
      left: -9.999975px;
    }
    li.over {
      background: @warning-color;
      font-weight: bold;
      &:hover {
        background: fade(@warning-color, 80);
      }
      cursor: pointer;
    }
    li.router-link-active {
      cursor: pointer;
      background: @base-color;
      &:hover {
        background: fade(@base-color, 80);
      }
    }

    li + li:not(.over):after {
      background: url("../assets/images/jt.jpg") no-repeat center;
    }
  }
  &.tbrView {
    > div {
      height: calc(~"100% - 10px");
    }
  }
}
.openOrclose {
  padding: 5.000025px 3px;
  color: #fff;
  position: absolute;
  top: 69.999975px;
  right: 5.000025px;
  width: 20.000025px;
  height: 84.999975px;
  line-height: 15.999975px;
  border-radius: 0 3px 3px 0;
  background: #404040 url("../assets/images/jt4.jpg") no-repeat center
    69.999975px;
  cursor: pointer;
}
.openOrclose.tbr {
  top: 9.999975px;
}
.openOrclose.open {
  background: #404040 url("../assets/images/jt3.jpg") no-repeat center
    69.999975px;
}
.ask {
  background: @base-Bg;
  padding: 20.000025px;
  margin-bottom: 20.000025px;
  > p {
    color: #333;
    font-size: 15.999975px;
    font-weight: bold;
    line-height: 27.999975px;
    span {
      color: #999;
      font-size: 14.000025px;
      margin-left: 9.999975px;
      font-weight: normal;
    }
  }
  div {
    font-size: 15.999975px;
    line-height: 27.999975px;
    p.right {
      text-align: right;
      margin-top: 20.000025px;
    }
  }
}
.reply {
  border-top: 0.999975px dashed #ddd;
  padding-top: 20.000025px;
  margin-bottom: 39.999975px;
  font-size: 15.999975px;
  span.lf {
    color: #333;
  }
  div.hfnr {
    margin-left: 45px;
    line-height: 27.999975px;
  }
  p.right {
    text-align: right;
    margin-top: 20.000025px;
    color: #999;
  }
  .notReply {
    text-align: center;
    margin-left: 0;
  }
}

.content .questionsTips {
  width: 258px;
  height: 54px;
  min-height: 9.999975px;
  background: url("../assets/images/tyBorder.png") no-repeat center center;
  background-size: 100% 100%;
  position: absolute;
  top: -17.000025px;
  right: 129.999975px;
  padding: 14.000025px 17.000025px;
  .tipsContent {
    font-size: 18px;
    color: #d70a30;
    line-height: 27.999975px;
  }
  .xBtn {
    width: 12.500025px;
    height: 12.500025px;
    position: absolute;
    top: 21.999975px;
    right: 20.000025px;
    z-index: 100;
  }
}
.mark {
  animation: blink 1s infinite;
  animation-direction: alternate;
  animation-timing-function: linear;
}
@keyframes blink {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(1.15);
  }
}
.replyText,
.boldFont {
  font-weight: bold;
  color: #333333;
  font-size: 17.000025px !important;
}
.maxHeight {
  .el-dialog {
    height: 600px;
  }
}
.addMaxHeight {
  .el-dialog {
    height: 620.000025px;
    .el-form-item {
      margin-bottom: 20px;
    }
  }
}
.editorMargin {
  margin-top: 3.999975px;
}
.fileBox {
  padding: 0 20.000025px 20.000025px;
}
.addFileBox {
  padding: 0 20.000025px 20.000025px 0;
  .upBtn.el-button {
    margin: 0 9.999975px 0 0;
  }
  .fileItem {
    padding-left: 0px;
    height: 20.000025px;
    line-height: 20.000025px;
  }
}
.upBtn.el-button {
  width: 60px !important;
  height: 24px !important;
  min-width: 0.999975px !important;
  background: #d70a30 !important;
  border-radius: 3px !important;
  font-size: 14.000025px;
  color: #ffffff;
  line-height: 27px;
  margin: 0 9.999975px;
}
.fileItem {
  padding-left: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 9.999975px 0;
  .fileIcon {
    width: 20.000025px;
    height: 20.000025px;
    vertical-align: bottom;
    padding-right: 5.000025px;
  }
  .twoIcon {
    width: 54px;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .upIcon {
      width: 24.999975px;
      height: 24.999975px;
      cursor: pointer;
    }
    .delIcon {
      width: 24.999975px;
      height: 24.999975px;
      cursor: pointer;
    }
  }
}
.fileItem:hover {
  background: #f6f7fa;
}
.edui-default .edui-editor-toolbarbox {
  display: none;
}
.askFileList {
  .fileItem {
    width: 80%;
    padding: 0;
    justify-content: flex-start;
    .fileIcon {
      vertical-align: sub;
    }
    p:hover {
      color: #1989fa;
    }
  }
  .fileItem:hover {
    background: transparent;
  }
  .twoIcon {
    margin-left: 20.000025px;
    cursor: pointer;
  }
}
.atOnceOpen {
  width: 999.999975px;
  height: 750px;
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .frameView {
    width: 100%;
    height: 100%;
    margin: auto;
    border: 30px solid #fff;
  }
  .btnDiv {
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translate(-50%);
  }
  .wlqz,
  .sjqz {
    width: 159.999975px;
    height: 159.999975px;
    border-radius: 5.000025px;
    color: #fff;
    margin: 9.999975px 24.999975px 9.999975px;
    padding-top: 99.999975px;
    font-size: 15.999975px;
  }
  .wlqz {
    background: #d70a30 url(../assets/images/wlcaImg.png) center 30px no-repeat;
    background-size: 47.000025px;
  }
  .sjqz {
    background: #d70a30 url(../assets/images/sjcaImg.png) center 30px no-repeat;
    background-size: 47.000025px;
  }
  // .el-dialog__header {
  //   // background-color: #d70a30;
  //   background-color: transparent;
  //   .el-dialog__close,
  //   .el-dialog__title {
  //     color: #fff;
  //   }
  // }
}
// .qzPdfBox {
//   width: 80%;
//   height: 80%;
//   position: fixed;
//   z-index: 10000;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   border: 30px solid #fff;
//   border-top: none;
//   border-bottom: 40px solid #fff;
//   outline: none;
//   background: #fff;
//   .controlsIframe {
//     position: absolute;
//     right: -25px;
//     top: 5px;
//     color: #000;
//     cursor: pointer;
//   }
//   .pdfirame {
//     width: 100%;
//     height: 100%;
//     border: none;
//   }
// }
.qzDialog {
  height: 100%;
  .el-dialog {
    height: 90%;
    margin-top: 0 !important;
    // top: 5%;
    .el-dialog__header {
      padding: 0;
      border: none;
    }
    .el-dialog__body {
      padding-top: 0px;
      padding-left: 20px;
      padding-bottom: 40px;
      padding-right: 8px;
    }
  }
}
.xmlc {
  .el-loading-mask {
    z-index: 10000;
  }
}
</style>
